import { toast } from "sonner";
import { api, apiError } from "./api";

// Complete gets the same 10-second Undo as No-show and Cancel. The invoice
// email is held on the server for a little longer than this, so an Undo inside
// the window means the client never receives anything at all.
export const COMPLETE_UNDO_MS = 10000;

// Toast action object shared by every place Complete can be tapped.
export function undoCompleteAction(sessionId, after) {
  return {
    label: "Undo",
    onClick: async () => {
      try {
        const { data } = await api.post(`/sessions/${sessionId}/restore`);
        toast.success(
          data?.invoice_removed
            ? `Back to scheduled — invoice ${data.invoice_removed} removed, no email sent`
            : "Back to scheduled — completion undone",
        );
        if (after) await after();
      } catch (err) {
        toast.error(apiError(err, "Couldn't undo — please try again"));
      }
    },
  };
}

// Why a completed class can't be undone any more, or null when it can.
// Mirrors the server rules: paid is never touched, and an invoice the client
// has already received has to be deleted by hand first. Invoices raised before
// this feature existed carry no email state, so they count as already emailed.
export function completeUndoBlockReason(invoice) {
  if (!invoice) return null;
  const paid = (invoice.status || "").toLowerCase() === "paid" || !!invoice.paid_at;
  if (paid) return "This class has been invoiced and paid. Nothing can be changed here.";
  const state = invoice.email_state;
  const emailed =
    !!invoice.emailed_at ||
    state === "sent" ||
    state === "sending" ||
    state === "needs_review" ||
    (state === undefined && !invoice.awaiting_abn);
  if (emailed) return "This class has been invoiced. Delete the invoice first.";
  return null;
}
